var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.961914C15.1354 0.961914 15.2526 1.01139 15.3516 1.11035C15.4505 1.20931 15.5 1.3265 15.5 1.46191C15.5 1.59733 15.4505 1.71452 15.3516 1.81348L8.35156 8.81348C8.2526 8.91243 8.13542 8.96191 8 8.96191C7.86458 8.96191 7.7474 8.91243 7.64844 8.81348L0.648438 1.81348C0.549479 1.71452 0.5 1.59733 0.5 1.46191C0.5 1.3265 0.549479 1.20931 0.648438 1.11035C0.747396 1.01139 0.864583 0.961914 1 0.961914C1.13542 0.961914 1.2526 1.01139 1.35156 1.11035L8 7.75098L14.6484 1.11035C14.7474 1.01139 14.8646 0.961914 15 0.961914Z",
    fill: "#484644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.b1e4ae565809b546cad108f70cde71bb.svg";
export { ForwardRef as ReactComponent };